export default __webpack_public_path__ + "static/media/reactjs.e4ad4fb6.svg";